/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateTemplateV2Request extends models.TemplateV2Base {
    getFixupPrototypeFunction() { return UpdateTemplateV2Request.fixupPrototype; }

    static newInstance(model: Partial<UpdateTemplateV2Request>): UpdateTemplateV2Request {
        let obj = Object.assign(new UpdateTemplateV2Request(), model);
        UpdateTemplateV2Request.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateTemplateV2Request>): UpdateTemplateV2Request {
        if (!model) return null;
        return UpdateTemplateV2Request.newInstance(<UpdateTemplateV2Request> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateTemplateV2Request) {
        if (!obj) return;

        models.UpdateTemplateV2Request.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateTemplateV2Request): boolean {
        if (models.TemplateV2Base.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UpdateTemplateV2Request.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
